import axios from "axios";

const getProductList = async (companyId) => {
  try {
    const response = await axios.get(
      "/consumer/system-admin/api/v1/data-summary/product-list",
      {
        params: {
          company_id: companyId,
        },
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    if (response.data.success && Array.isArray(response.data.data)) {
      const transformedData = {
        ...response.data,
        data: response.data.data.map((product) => ({
          productUuid: product.product_uuid,
          productName: product.product_name,
        })),
      };
      return transformedData;
    }
    return response.data;
  } catch (error) {
    const errorResponse = {
      success: false,
      error: error.response?.data?.message || error.message,
      code: error.response?.data?.code || "ERROR_UNKNOWN",
      data: [],
      details: error.response?.data?.data || null,
    };
    throw errorResponse;
  }
};

export default getProductList;
